export const ROLE_ADMIN = 1
export const ROLE_KONTRIBUTOR = 2
export const ROLE_KURATOR = 3

export default {
    ROLE_ADMIN,
    ROLE_KONTRIBUTOR,
    ROLE_KURATOR,
}